<template>
  <div class="form">
    <!-- <van-cell-group> -->
      <van-field
        class="form__textarea"
        v-model="comment"
        type="textarea"
        placeholder="请输入留言"
        maxlength="100"
        :border="false"
        :autosize="autosize"
      />
    <!-- </van-cell-group> -->

    <!-- <van-field
      v-model="nickname"
      required
      clearable
      label="花名"
      placeholder="请输入花名（管理员联系用）"
    /> -->

    <van-button
      class="form__btn"
      type="primary"
      size="small"
    >留言</van-button>
  </div>
</template>

<script>
import { CellGroup, Field, Cell, Switch, Icon, Button, Popup, DatetimePicker } from 'vant'
// import api from '@/api'

export default {
  name: 'CreateComment',
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
  },
  data () {
    return {
      id: '',
      comment: '',
      autosize: {
        minHeight: 100
      }
    }
  },
  methods: {
  },
  created () {
    // this.commentList()
  }
}
</script>

<style lang="less" scoped>
.form {
  padding: 0 20px;
  &__textarea {
    padding: 20px 0;
    border-bottom: 1px solid #f1f1f1;
    font-size: 14px;
    line-height: 20px;
  }
  &__btn {
    display: block;
    margin: 20px auto;
    width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/createComment/index.vue